import { IRootState } from '@/store/state';
import { ModuleTree } from 'vuex';
import { DashboardModuleStore } from '@/modules/dashboard/store';
import { OrganisationModuleStore } from '@/modules/organisation/store';
import { AMDashboardModuleStore } from '@/modules/amDashboard/store';
import { SubmissionModuleStore } from '@/modules/submission/store';
import { AuthModuleStore } from '@/modules/auth/store';
import { FundModuleStore } from '@/modules/fund/store';
import { PensionSchemeModuleStore } from '@/modules/pensionScheme/store';
import { CostAnalysisModuleStore } from '@/modules/costAnalysis/store';
import { ReportingModuleStore } from '@/modules/reporting/store';
import { UserModuleStore } from '@/modules/user/store';
import { SubFundModuleStore } from '@/modules/subFund/store';
import { AssociateUserModuleStore } from '@/modules/associateUser/store';
import { ForecastModuleStore } from '@/modules/forecast/store';
import { AssetOwnerModuleStore } from '@/modules/assetOwner/store';
import { MrtModuleStore } from '@/modules/machineReadableTemplate/store';
import { AnalysisModuleStore } from '@/modules/analysis/store';
import { FilterModuleStore } from '@/components/ui/filters/store';
/**
 * --------------------------------------------------
 *	Application Modules
 * --------------------------------------------------
 **/
export const AppModules: ModuleTree<IRootState> = {
  AuthModuleStore,
  DashboardModuleStore,
  OrganisationModuleStore,
  AMDashboardModuleStore,
  SubmissionModuleStore,
  FundModuleStore,
  PensionSchemeModuleStore,
  CostAnalysisModuleStore,
  ReportingModuleStore,
  UserModuleStore,
  SubFundModuleStore,
  AssociateUserModuleStore,
  ForecastModuleStore,
  MrtModuleStore,
  AssetOwnerModuleStore,
  AnalysisModuleStore,
  FilterModuleStore
};
